import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { generateRandomId } from "../../components/common/GenerateRandomId/GenerateRandomId";
import CustomMessage from "../../components/common/Snackbar/Snackbar";
import { axiosInstance } from "../../network/apis";
import { DELETE_UPLOADED_FILE_URL, GET_APPLY_LEAVE_HISTORY, GET_LEAVE_DETAILS, GET_SELECTED_APPLY_LEAVE_CARD_DATAS, GET_UPLOADFILE_OBJECT_ID_URL, POST_CANCELLED_LEAVE, POST_REQUEST_LEAVE_DETAILS } from "../../network/apis/apiPath";
import { CREAT_LEAVE_PATH } from "../../utils/Constants";
import { getLocalStoreString } from "../../utils/Helper";
import { APPLY_LEAVE, APPLY_LEAVE_HISTORY, CANCEL_LEAVE, DELETE_LEAVE_UPLOADEDFILE, GET_UPLOADFILE_OBJECT_ID, LEAVE_DETAILS, SELECTED_CARD_DETAILS } from "../type";
import { deleteSelectedFiles, saveLeaveDetailsData, saveLeaveDetailsHistoryData, saveSelectedCardLeaveData, saveSelectedUploadFiles, saveUploadfileObjectId } from "./leaveConfigSlice";



function* leaveDetailsConfigWorker(action) {
    const { EmployeeCode } = action.payload
    try {
        const response = (yield call(axiosInstance.get, `${GET_LEAVE_DETAILS}?employeeCode=${EmployeeCode}`))
        if (response.data) {
            yield put(saveLeaveDetailsData(response.data))
        }

    } catch (error) {
        console.log(error);
    }
}

function* applyLeaveConfigWorker(action) {
    const { payload, enqueueSnackbar, setOpen, } = action
    try {
        const response = (yield call(axiosInstance.post, POST_REQUEST_LEAVE_DETAILS, payload));

        if (response.data) {
            setOpen(true)
        }
    } catch (error) {
        const errorContent = error?.response?.data?.message
        CustomMessage(errorContent, "error", enqueueSnackbar);
    }
}

function* applyLeaveHistoryWorker(action) {
    const { employeeCode, month, year } = action.payload
    try {
        const response = (yield call(axiosInstance.get, `${GET_APPLY_LEAVE_HISTORY}?employeeCode=${employeeCode}&month=${month}&year=${year}`));
        if (response.data) {
            yield put(saveLeaveDetailsHistoryData(response.data))
        }

    } catch (error) {
        console.log(error);
    }
}

function* getSelectedCardDataWorker(action) {
    const { employeeCode, applicationId, navigate, leaveDetailsData } = action.payload
    try {
        const response = (yield call(axiosInstance.get, `${GET_SELECTED_APPLY_LEAVE_CARD_DATAS}/${applicationId}?employeeCode=${employeeCode}`))
        if (response.data) {
            yield put(saveSelectedCardLeaveData(response.data))
            navigate(CREAT_LEAVE_PATH, { state: { selectedCardLeaveData: response.data, cardViewed: true, leaveDetailsData: leaveDetailsData }, })
        }
    } catch (error) {
        console.log(error);
    }
}

function* cancelAppliedLeaveWorker(action) {
    const { payload, enqueueSnackbar, setOpen, setCancelled, setViewImage } = action
    try {
        const response = (yield call(axiosInstance.post, POST_CANCELLED_LEAVE, payload));

        if (response.data) {
            setViewImage(false)
            setCancelled(true)
            setOpen(true)
        }
    } catch (error) {
        const errorContent = error?.response?.data?.message
        CustomMessage(errorContent, "error", enqueueSnackbar);
    }

}

function* getUploadfileObjectIdWorker(action) {

    const BearerToken = localStorage.getItem("BearerToken");
    const TenantId = getLocalStoreString("CompanyID");

    const { uploadFile, employeeCode } = action.payload
    const endnameFormate = uploadFile.file.name.split('.')[1]
    const formData = new FormData();
    formData.append('file', uploadFile.file)
    try {
        const response = (yield call(axios.post, `${GET_UPLOADFILE_OBJECT_ID_URL}?employeeCode=${employeeCode}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": `Bearer ${BearerToken}`,
                "Tenant-Id": TenantId,
            }
        }));
        if (response) {
            const { id } = response.data
            const objectId = 'objectId';
            const fileName = 'fileName';
            const updatedObject = { [objectId]: id, [fileName]: `attachment${generateRandomId(2)}.${endnameFormate}` }
            const addRandomId = { ...updatedObject, randomId: uploadFile.randomId }
            yield put(saveUploadfileObjectId(addRandomId))
            yield put(saveSelectedUploadFiles(uploadFile))
        }

    } catch (error) {
        console.log('error', error);
    }
}

function* deleteLeaveUploadFile(action) {
    const { deleteFile, employeeCode, enqueueSnackbar, } = action.payload;
    try {
        const response = (yield call(axiosInstance.delete, `${DELETE_UPLOADED_FILE_URL}?objectId=${deleteFile?.objectId}&employeeCode=${employeeCode}`));
        if (response?.status == 200) {
            CustomMessage('Deleted Successfully', "success", enqueueSnackbar);
            yield put(deleteSelectedFiles(deleteFile.randomId))
        }
    } catch (error) {
        const errorContent = error?.response?.data?.message
        CustomMessage(errorContent, "error", enqueueSnackbar);
    }
}

export function* leaveConfigWatcher() {
    yield takeLatest(LEAVE_DETAILS, leaveDetailsConfigWorker);
    yield takeLatest(APPLY_LEAVE, applyLeaveConfigWorker);
    yield takeLatest(APPLY_LEAVE_HISTORY, applyLeaveHistoryWorker);
    yield takeLatest(SELECTED_CARD_DETAILS, getSelectedCardDataWorker);
    yield takeLatest(CANCEL_LEAVE, cancelAppliedLeaveWorker);
    yield takeLatest(GET_UPLOADFILE_OBJECT_ID, getUploadfileObjectIdWorker);
    yield takeLatest(DELETE_LEAVE_UPLOADEDFILE, deleteLeaveUploadFile)
}